module.exports = __webpack_public_path__ + "static/media/icon-video.f798e7bd.svg";